import { c as _c } from "react/compiler-runtime";
import { Modal, PaymentProcessorEnum, PrimaryButton, SecondaryButton, toast } from '@systemeio/ui';
import { BadRequest } from '@systemeio/util';
import { InternalError } from '@systemeio/util';
import { refundTransaction, refundTransactionNew } from 'modules/payment/transactions/api/transactions-api';
import React, { useState } from 'react';
import { FieldErrorAndDescription } from 'shared/components/form/field-error-and-description';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
interface RefundConfirmationProps {
  opened: boolean;
  transactionId: number;
  paymentProcessorName: PaymentProcessorEnum;
  onClose: () => void;
  onUpdate: () => Promise<void>;
}
const RefundConfirmation = t0 => {
  const $ = _c(46);
  const {
    opened,
    transactionId,
    paymentProcessorName,
    onClose,
    onUpdate
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const [error, setError] = useState("");
  const [isFetching, setIsFetching] = useState(false);
  let t1;
  if ($[0] !== paymentProcessorName || $[1] !== transactionId) {
    t1 = async () => {
      if (paymentProcessorName === "secure-and-pay") {
        await refundTransactionNew(transactionId, null, paymentProcessorName);
      } else {
        await refundTransaction(transactionId);
      }
    };
    $[0] = paymentProcessorName;
    $[1] = transactionId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleRefund = t1;
  let t2;
  if ($[3] !== handleRefund || $[4] !== onClose || $[5] !== onUpdate || $[6] !== t) {
    t2 = async () => {
      ;
      try {
        setIsFetching(true);
        await handleRefund();
        setIsFetching(false);
        await onUpdate();
        toast.success(t("dashboard.transactions.payment_has_refunded"));
        onClose();
      } catch (t3) {
        const e = t3;
        setIsFetching(false);
        if (e instanceof BadRequest) {
          if (e.errors.common) {
            setError(e.errors.common.join(""));
          }
        } else {
          if (e instanceof InternalError) {
            setError(t("core.error.internal_error_message"));
          }
        }
      }
    };
    $[3] = handleRefund;
    $[4] = onClose;
    $[5] = onUpdate;
    $[6] = t;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const onRefund = t2;
  let t3;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => setError("");
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const onModalClose = t3;
  let t4;
  if ($[9] !== t) {
    t4 = t("dashboard.transactions.refund_confirmation");
    $[9] = t;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t) {
    t5 = t("dashboard.transactions.refund_confirmation-text");
    $[11] = t;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t5) {
    t6 = <div className="flex justify-center"><p>{t5}</p></div>;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== onClose) {
    t7 = e_0 => {
      e_0.preventDefault();
      onClose();
    };
    $[15] = onClose;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t) {
    t8 = t("confirmation_modal.cancel");
    $[17] = t;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== isFetching || $[20] !== t7 || $[21] !== t8) {
    t9 = <SecondaryButton width="large" onClick={t7} disabled={isFetching}>{t8}</SecondaryButton>;
    $[19] = isFetching;
    $[20] = t7;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== onRefund) {
    t10 = async e_1 => {
      e_1.preventDefault();
      await onRefund();
    };
    $[23] = onRefund;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== t) {
    t11 = t("confirmation_modal.confirm");
    $[25] = t;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== isFetching || $[28] !== t10 || $[29] !== t11) {
    t12 = <PrimaryButton isFetching={isFetching} width="large" onClick={t10} type="submit">{t11}</PrimaryButton>;
    $[27] = isFetching;
    $[28] = t10;
    $[29] = t11;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  let t13;
  if ($[31] !== t12 || $[32] !== t9) {
    t13 = <div className="flex justify-center gap-4">{t9}{t12}</div>;
    $[31] = t12;
    $[32] = t9;
    $[33] = t13;
  } else {
    t13 = $[33];
  }
  let t14;
  if ($[34] !== error) {
    t14 = <FieldErrorAndDescription error={error} errorClassName="text-center mt-2" />;
    $[34] = error;
    $[35] = t14;
  } else {
    t14 = $[35];
  }
  let t15;
  if ($[36] !== t13 || $[37] !== t14 || $[38] !== t6) {
    t15 = <form className="flex flex-col gap-6">{t6}{t13}{t14}</form>;
    $[36] = t13;
    $[37] = t14;
    $[38] = t6;
    $[39] = t15;
  } else {
    t15 = $[39];
  }
  let t16;
  if ($[40] !== isFetching || $[41] !== onClose || $[42] !== opened || $[43] !== t15 || $[44] !== t4) {
    t16 = <><Modal opened={opened} onClose={onClose} title={t4} afterLeave={onModalClose} isFetching={isFetching} isCentered={true}>{t15}</Modal></>;
    $[40] = isFetching;
    $[41] = onClose;
    $[42] = opened;
    $[43] = t15;
    $[44] = t4;
    $[45] = t16;
  } else {
    t16 = $[45];
  }
  return t16;
};
export default RefundConfirmation;